import fbconfig from '@/firebase-config'

export default {

    namespaced: true,

    state: {
        photos: [],
        activePhotos: []
    },

    getters: {

        photoUrl: () => (photo, size) => {
            //console.log(`store.photos.getters.photoUrl() ${size}`);
            const sizes = { thumb: '90px', medium: '600px', full: '1200px' };
            return `${location.protocol}//storage.googleapis.com/${fbconfig.storageBucket}/images/gcphoto-${photo.id}-${sizes[size]}.${photo.ext}`;
        },

        photoObject: () => (id, ext) => {
            if (!id || !ext) return;
            //console.log(`store.getters.photos.photoObject() id [${id}] ext [${ext}]`);
            let photos = { id: id };
            photos.thumb = `storage.googleapis.com/${fbconfig.storageBucket}/images/gcphoto-${id}-90px.${ext}`;
            photos.medium = `storage.googleapis.com/${fbconfig.storageBucket}/images/gcphoto-${id}-600px.${ext}`;
            photos.full = `storage.googleapis.com/${fbconfig.storageBucket}/images/gcphoto-${id}-1200px.${ext}`;
            return photos;
        },

        photosLoaded: (state) => (photo_ids) => {
            //console.log(`store.photos.getters.photosLoaded() compare [${photo_ids}] to activePhotos`);
            if (state.photos.length === photo_ids.length) {
                const result = state.photos.reduce((result, photo, index) => photo.id === photo_ids[index], true);
                return result
            } else {
                return false;
            }
        },

        photosSummary(state) {
            //console.log(`store.photos.getters.photosSummary() summarize ${state.activePhotos.length} photos`);
            if (state.activePhotos.length > 0) {

                let sum = [];

                state.activePhotos.forEach(photo => {
                    let extIndex = photo.name.lastIndexOf('.');
                    if (extIndex == -1) extIndex = photo.name.length;
                    let pName = photo.name ? photo.name.substr(0, extIndex) : '';
                    sum.push({
                        id: photo._id,
                        pos: photo.pos,
                        ext: photo.ext || 'jpg',
                        name: pName,
                        caption: photo.caption || ''
                    })
                });

                if (sum[0].pos == 'front') return sum;
                else return sum.reverse();
            }
        },

        photoSummary:() => (photo) => {
            console.log(`store.photos.getters.photoSummary() summarize photo:`);
            console.dir(photo)
            let pName = photo.name ? photo.name.substr(0, photo.name.indexOf(photo.ext) - 1) : '';
            let sum = {
                id: photo._id,
                pos: photo.pos,
                ext: photo.ext || 'jpg',
                name: pName,
                caption: photo.caption || ''
            };
            return sum;
        }
    },

    actions: {

        addPhotos({ commit, getters }, { files, postcard_id }) {
            console.log(`store.photos.actions.addPhotos() save [${files.length}] photos to postcard [${postcard_id}]`);
            commit('resetActive');
            // first load photo to storage
            const storageRef = this.$fbstoreage.ref();
            const fb = this.$fbdb.app.firebase_;
            let frontName;
            let photoMetadata = [];
            if (files.length == 2) {
                frontName = files[0].name;
            }
            let promises = files.map(file => {
                console.log(`store.photos.actions.addPhotos() add file to storage`);
                console.dir(file);
                const fileRef = storageRef.child(file.name);
                return fileRef.put(file)
                    .then((snapshot) => {
                        console.log(`store.photos.actions.addPhotos() file added`);
                        photoMetadata.push(snapshot.metadata);
                        // push data into photos
                        return Promise.resolve(snapshot);
                    })
                    .catch(err => { throw (err) })
            });
            return Promise.all(promises)
                .then(() => {
                    console.log(`store.photos.actions.addPhotos() photos uploaded to storage`);
                    console.dir(photoMetadata);
                    // then save photo data to postcard collection
                    const photoRef = this.$fbdb.collection('postcards').doc(postcard_id).collection('photos');
                    let promises = photoMetadata.map((meta) => {
                        // Add some upload data to the photo doc
                        console.log(`store.photos.actions.addPhotos() photo metadata`);
                        console.dir(meta);
                        const photo_id = meta.generation;
                        const ext = meta.name.slice(meta.name.lastIndexOf('.') + 1);
                        let photo = getters.photoObject(photo_id, ext);
                        photo.Created_date = fb.firestore.Timestamp.now();
                        photo.content_type = meta.contentType;
                        photo.ext = ext;
                        photo.name = meta.name;
                        photo.postcard = postcard_id;
                        photo.pos = photo.name == frontName ? 'front' : 'back';
                        console.log(`store.photos.actions.addPhotos() create photo ${photo_id}`);
                        return photoRef.doc(photo_id).set(photo)
                            .then(() => {
                                // push new photo into activePhotos
                                return photoRef.doc(photo_id).get()
                                    .then(photoSnapshot => {
                                        console.log(`store.photos.actions.addPhotos() photo created`);
                                        console.dir(photoSnapshot.data());
                                        let p = Object.assign({_id: photo_id}, photoSnapshot.data());
                                        commit('addPhoto', p, false);
                                        return Promise.resolve(p);
                                    })
                            })
                            .catch(err => { throw (err) })
                    });
                    return Promise.all(promises)
                        .then((photos) => {
                            // all photos are created and we're done
                            console.log(`store.photos.actions.addPhotos() all photo have been created`);
                            console.dir(photos);
                            return Promise.resolve(photos);
                        })
                })
                .catch(err => {
                    console.warn('store.photos.actions.addPhotos() ERROR');
                    console.dir(err);
                    throw ({ message: 'Failed to create photos entry.' });
                })
        },

        addPhoto({ commit, getters }, { file, postcard_id, pos }) {
            console.log(`store.photos.actions.addPhotos() save photos to postcard [${postcard_id}]`);
            console.dir(file);
            // first load photo to storage
            const storageRef = this.$fbstoreage.ref();
            const fb = this.$fbdb.app.firebase_;
            const fileRef = storageRef.child(file.name);
            const photoRef = this.$fbdb.collection('postcards').doc(postcard_id).collection('photos');
            return fileRef.put(file)
                .then((snapshot) => {
                    console.log(`store.photos.actions.addPhoto() file added`);
                    let meta = snapshot.metadata;
                    // Add some upload data to the photo doc
                    console.log(`store.photos.actions.addPhotos() photo metadata`);
                    console.dir(meta);
                    const photo_id = meta.generation;
                    const ext = meta.name.slice(meta.name.lastIndexOf('.') + 1);
                    let photo = getters.photoObject(photo_id, ext);
                    photo.Created_date = fb.firestore.Timestamp.now();
                    photo.content_type = meta.contentType;
                    photo.ext = ext;
                    photo.name = meta.name;
                    photo.postcard = postcard_id;
                    photo.pos = pos;
                    console.log(`store.photos.actions.addPhoto() create photo ${photo_id}`);
                    return photoRef.doc(photo_id).set(photo)
                        .then(() => {
                            // push new photo into activePhotos
                            return photoRef.doc(photo_id).get()
                                .then(photoSnapshot => {
                                    console.log(`store.photos.actions.addPhoto() photo created`);
                                    console.dir(photoSnapshot.data());
                                    let p = Object.assign({_id: photo_id}, photoSnapshot.data());
                                    commit('addPhoto', p, false);
                                    return Promise.resolve(p);
                                })
                        })
                        .catch(err => { throw (err) })
                })
                .catch(err => { throw (err) })
        },

        getPostcardPhotos({ commit }, postcard_id) {
            console.log(`store.photos.actions.getPostcardPhotos() postcard_id [${postcard_id}]`);
            const photoRef = this.$fbdb.collection('postcards').doc(postcard_id).collection('photos');
            let photos = [];
            return photoRef.get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        photos.push(doc.data());
                    });
                    commit('setActivePhotos', photos);
                    return Promise.resolve(photos);
                })
                .catch(err => { throw (err) })
        },

        deletePhoto({commit}, {postcard_id, photo_id}) {
            console.log(`store.actions.photos.deletePhoto() postcard_id ${postcard_id} photo_id [${photo_id}]`);
            console.dir(arguments);
            let photoRef = this.$fbdb.collection('postcards').doc(postcard_id).collection('photos').doc(photo_id);
            return photoRef.get()
                .then((docSnapshot) => {
                    let storageRef = this.$fbstoreage.ref();
                    let photo = docSnapshot.data();
                    let i = photo.thumb.indexOf('/images/');
                    let deletes = []
                    let fileRefs = [
                        storageRef.child(photo.thumb.slice(i)),
                        storageRef.child(photo.medium.slice(i)),
                        storageRef.child(photo.full.slice(i))
                    ];
                    fileRefs.forEach(ref => {
                        deletes.push(ref.delete());
                    });
                    deletes.push(photoRef.delete());
                    return Promise.all(deletes)
                        .then(() => {
                            commit('removePhoto', photo_id);
                            return Promise.resolve(true);
                        })
                        .catch(err => { throw (err) })
                })
                .catch(err => { throw (err) })
        },

        deletePhotos({commit}, querySnapshot) {
            console.log(`store.actions.photos.deletePhotos() delete [${querySnapshot.size}] photos`);
            let deletes = [];
            querySnapshot.forEach(doc => {
                const photo = doc.data();
                const i = photo.thumb.indexOf('/images/');
                const storageRef = this.$fbstoreage.ref();
                const fileRefs = [
                    storageRef.child(photo.thumb.slice(i)),
                    storageRef.child(photo.medium.slice(i)),
                    storageRef.child(photo.full.slice(i))
                ];
                fileRefs.forEach(ref => {
                    deletes.push(ref.delete());
                });
                deletes.push(doc.ref.delete());
            });
            if (deletes.length === 0) {
                return Promise.resolve('no photos');
            } else {
                //console.log(`store.actions.photos.deletePhotos() ${deletes.length} photo refs to delete`);
                return Promise.all(deletes)
                    .then(() => {
                        commit('removePhotos', querySnapshot);
                        return Promise.resolve(true);
                    })
            }
        }

    },

    mutations: {

        resetActive(state) {
            state.activePhotos = [];
        },

        setActivePhotos(state, photos) {
            state.activePhotos = photos;
        },

        addPhoto(state, photo, skip) {
            console.log(`store.mutations.photos.addPhoto() skip [${skip}]`);
            console.dir(photo);
            state.activePhotos.push(photo);
            // Add to big list if new
            if (skip) {
                console.log(`store.mutations.photos.addPhoto() skip add`);
            } 
            if (state.photos.findIndex(p => p._id == photo._id) > -1) {
                console.log(`store.mutations.photos.addPhoto() photo [${photo._id}] already in array`);
            } 
            else {
                state.photos.push(photo);
            }
        }, 

        addPhotos({commit}, photos) {
            photos.each((p) => commit('addPhoto', p))
        },

        removePhotos(state, querySnapshot) {
            console.log(`store.mutations.photos.removePhotos() remove ${querySnapshot.size} photos`);
            console.dir(querySnapshot);
            querySnapshot.forEach(doc => {
                let photo_id = doc.id;
                let i = state.photos.findIndex(p => p._id == photo_id);
                if (i > -1) {
                    console.log(`store.mutations.photos.removePhotos() remove photo at index [${i}] from photos`);
                    state.photos.splice(i, 1);
                }
                i = state.activePhotos.findIndex(p => p._id == photo_id);
                if (i > -1) {
                    console.log(`store.mutations.photos.removePhotos() remove photo at index [${i}] from activePhotos`);
                    state.activePhotos.splice(i, 1);
                }
            })
        },

        removePhoto(state, photo_id) {
            let i = state.photos.findIndex(p => p._id == photo_id);
            if (i > -1) {
                console.log(`store.mutations.photos.removePhoto() remove photo at index [${i}]`);
                state.photos.splice(i, 1);
            }
        }
    }
}